import React, { useContext, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { formatSectorLabel } from '../../utils/labelFormatters';

const ChartBySector = ({ getRows, setDataChartSectors }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport, verifySort, capitalizeFirstLetter } = getItensStateGlobal;

  const chartRef = useRef(null);

  const queues = storageDataReport.queues || {};
  const labelToQueueKey = Object.keys(queues).reduce((acc, key) => {
    acc[formatSectorLabel(key)] = key;
    return acc;
  }, {});
  const labels = Object.keys(labelToQueueKey);
  
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        // text: 'Chart.js Bar Chart',
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Atendidas',
        data: labels.map((label) => (queues[labelToQueueKey[label]] && queues[labelToQueueKey[label]].atendidas) ?? 0),
        backgroundColor: 'rgba(30, 144, 255, 0.7)',
        datalabels: {
          align: 'top'
        },
      },
      {
        label: 'Não Atendidas',
        data: labels.map((label) => (queues[labelToQueueKey[label]] && queues[labelToQueueKey[label]].perdidas) ?? 0),
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
        datalabels: {
          align: 'top'
        },
      },
    ],
  };

  const getDataToRequestFilter = (event) => {
    if (chartRef.current) {
    const chart = ChartJS.getChart(chartRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];

      const originalKey = labelToQueueKey[labelIndexClicked] || labelIndexClicked;
      labelType === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';
      getRows('queues', originalKey, labelType);
    }
   }
  };

  const exportExcelDownload = () => {
    const arrayAtendidas = valueLabelsAtendidas[0];
    const arrayNaoAtendidas = valueLabelsNaoAtendidas[0];

    const data = labels.map((sector) => {
      const atendidas = arrayAtendidas ? arrayAtendidas : '0';
      const naoAtendidas = arrayNaoAtendidas ? arrayNaoAtendidas : '0';
      const objElements = { sector, atendidas, naoAtendidas };
      return objElements;
    });
    return { name: 'Chamadas_Setor', description: 'Chamadas Recebidas por Setor', data }
  };

  return (
    <div className="column is-half">
      <h2 className="has-text-centered is-size-5">Status das Chamadas por Setor</h2>
      <Bar
        options={options}
        data={data}
        ref={chartRef}
        getElementAtEvent={(_, event) => getDataToRequestFilter(event)}
        plugins={[ChartDataLabels]}
      />
    </div>
  );
}

ChartBySector.propTypes = {
  getRows: PropTypes.func,
};

export default ChartBySector;
